import { useContext, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { useNavigate } from "react-router-dom";
import VylabsIcon from "../../Assets/Images/VybogTAL-Logo.svg";
import vybogTALDarkLogo from "../../Assets/Images/VybogTAL-Logo-Dark.svg";
import { DynamicContext } from "../../Context/DynamicContext";
import {
  VYLABS_BASE_URL,
  GET_ALL_PLANS_DETAILS,
} from "../../helper/url_helper";
import { get } from "../../helper/Api_helper";
import PlansDetails from "../Settings-Pages/Subscription-Pages/PlansDetails";
import VybogTALLoaderAnimation from "../../Common/Dynamic-Animations/DynamicAnimations";
import { Toast } from "../../Common/Toast-Snackbar/ToastSnackbar";
import { TENANT_OTP_API_KEY } from "../../Tenant-Config/TenantConfig";

function SelectPlan() {
  const { isDarkMode } = useContext(DynamicContext);
  const [plansData, setPlansData] = useState([]);
  const [isLoadingPlans, setIsLoadingPlans] = useState(false);
  const [isTokenValid, setIsTokenValid] = useState(true);
  const navigate = useNavigate();

  const SectionTitle = styled.h2`
    text-align: center;
    font-size: 28px;
    color: var(--primary__color);
  `;

  const SectionDescription = styled.p`
    text-align: center;
    font-size: 16px;
    color: var(--page_Header_Color);
  `;

  const CardsContainer = styled.div`
    border: 1px solid #ccc;
    padding: 20px;
    margin: 35px;
    border-radius: 10px;
    width: 62%;
  `;

  const checkAccessTokenExpiry = () => {
    try {
      const adminSignupData = sessionStorage.getItem("adminSignupData");
      if (adminSignupData) {
        const { access_token_expires_at } = JSON.parse(adminSignupData);
        if (access_token_expires_at) {
          const expiryTime = new Date(access_token_expires_at);
          const currentTime = new Date();
          if (currentTime > expiryTime) {
            Toast(
              "warn",
              "Your session has expired. Please login to continue.",
            );
            sessionStorage.removeItem("adminSignupData");
            sessionStorage.removeItem("tempEmail");
            sessionStorage.removeItem("tempSignupData");
            navigate("/login");
            return false;
          }
          const timeRemaining = expiryTime.getTime() - currentTime.getTime();
          if (timeRemaining > 0) {
            setTimeout(() => {
              Toast(
                "warn",
                "Your session has expired. Please login to continue.",
              );
              sessionStorage.removeItem("adminSignupData");
              navigate("/login");
            }, timeRemaining);
          }
          return true;
        }
      }
      const tokenExpiry = localStorage.getItem("access_token_expires_at");
      if (tokenExpiry) {
        const expiryTime = new Date(tokenExpiry);
        const currentTime = new Date();

        if (currentTime > expiryTime) {
          Toast("warn", "Your session has expired. Please login to continue.");
          localStorage.removeItem("access_token");
          localStorage.removeItem("access_token_expires_at");
          localStorage.removeItem("refresh_token");
          navigate("/login");
          return false;
        }
      }
      if (!adminSignupData && !localStorage.getItem("access_token")) {
        Toast("warn", "Your session has expired. Please login to continue.");
        navigate("/login");
        return false;
      }

      return true;
    } catch (error) {
      console.error("Error checking token expiry:", error);
      Toast("warn", "Your session has expired. Please login to continue.");
      navigate("/login");
      return false;
    }
  };

  const getAllPlanDetails = async () => {
    try {
      if (!checkAccessTokenExpiry()) {
        setIsTokenValid(false);
        return;
      }

      setIsLoadingPlans(true);
      const response = await get(VYLABS_BASE_URL, GET_ALL_PLANS_DETAILS,
        {
          _skipAuth: true,
          headers: {
            "X-API-Key": TENANT_OTP_API_KEY,
          },
        },
      );
      if (response && response.plans) {
        setPlansData(response.plans);
      }
    } catch (error) {
      console.log("getAllPlanDetails", error);
      if (error.response?.status === 401) {
        Toast("warn", "Your session has expired. Please login to continue.");
        sessionStorage.removeItem("adminSignupData");
        navigate("/login");
      }
    } finally {
      setIsLoadingPlans(false);
    }
  };

  useEffect(() => {
    const tokenValid = checkAccessTokenExpiry();
    setIsTokenValid(tokenValid);

    if (tokenValid) {
      getAllPlanDetails();
    }
  }, []);
  if (!isTokenValid) {
    return null;
  }

  return (
    <>
      {isLoadingPlans ? (
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            height: "100vh",
          }}
        >
          <VybogTALLoaderAnimation />
        </div>
      ) : (
        <div
          className={`signup-outer-container ${isDarkMode ? "no-bg-image" : ""}`}
        >
          <div className="signup-icon-text">
            <img
              alt="VylabsIcon"
              src={isDarkMode ? vybogTALDarkLogo : VylabsIcon}
              className="vy-labs-logo"
            />
            <div className="signup-welcome-container">
              <h2 className="signup-main-header">
                Welcome to the future of recruitment
              </h2>
              <span className="signup-side-text">
                Smarter hiring starts here. Find, evaluate, and hire talent
                faster.
              </span>
            </div>
          </div>
          <SectionTitle>Choose Your Plan</SectionTitle>
          <SectionDescription>
            Each plan starts with a 14-day free trial (No credit card required),
            Please select a plan.
          </SectionDescription>
          <CardsContainer className="select-plan-outer-container">
            <PlansDetails plansData={plansData} isManualBilling={false} />
          </CardsContainer>
        </div>
      )}
    </>
  );
}

export default SelectPlan;
